export default __webpack_public_path__ + "images/780b1f96c4fea6d9d56b44a1b5643f6d.webp";